<app-breadcrumb [master]="'Administracja'" [parentName]="'Słownik'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-dynamic-dictionary-details-view *ngIf="!modify" [dynamicDictionary]="dynamicDictionar" (modifyClicked)="modify = true"></app-dynamic-dictionary-details-view>
    <app-dynamic-dictionary-add *ngIf="modify" [dynamicDictionary]="dynamicDictionaryObject" [mod]='true' (closeModification)="modify = false; load()" ></app-dynamic-dictionary-add>
  </mat-tab>

</mat-tab-group>

